import React, { useState } from 'react';
import '../Recorrido/Recorrido.scss';
import View360 from '../View360/View360';
import { useTranslation } from 'react-i18next';

const RecorridoHome = () => {
  const { t } = useTranslation();

  const [idScene, setId] = useState('cancha');
  const [yaw, setyaw] = useState(50);
  const [pitch, setpitch] = useState(0);

  const handleImagen = (tipo) => {
    const removeElement = document.getElementsByClassName('active');
    if (removeElement.length > 0) {
      removeElement[0].classList.remove('active');
    }
    const element = document.getElementById(tipo);
    if (element) {
      element.classList.add('active');
    }
    if (tipo === 'cancha') {
      setId('cancha');
      setyaw(50);
      setpitch(0);
    } else if (tipo === 'juegos') {
      setyaw(-30);
      setpitch(0);
      setId('juegos');
    }
  };

  return (
    <div className='contenedor_recorrido'>
      {idScene === 'cancha' && (
        <View360
          yaw={yaw}
          pitch={pitch}
          urlImagen='/assets/Artemisa/img-360-padel-velasur.jpg'
          idScene='cancha'
        ></View360>
      )}
      {idScene === 'juegos' && (
        <View360
          yaw={yaw}
          pitch={pitch}
          urlImagen='/assets/Artemisa/img-360-juegos-infantiles-velasur.jpg'
          idScene='juegos'
        ></View360>
      )}
      <span className='disclamer'>{t('recorridoHome.disclaimer')}</span>
      <div className='options'>
        <button id='cancha' className='active' onClick={() => handleImagen('cancha')}>
          {t('recorridoHome.padelCourt')}
        </button>
        <button id='juegos' onClick={() => handleImagen('juegos')}>
          {t('recorridoHome.playground')}
        </button>
      </div>
    </div>
  );
};

export default RecorridoHome;
